
export const removeSessionItems = (...args) => {
  args.forEach((item) => window.sessionStorage.removeItem(item));
};

export const getSessionItems = (...args) => {
  const results = args.map((item) => window.sessionStorage.getItem(item));
  return results || [];
};

export const setSessionItems = (items) => {
  Object.keys(items).forEach((itemKey) => {
    window.sessionStorage.setItem(itemKey, items[itemKey]);
  })
};

